import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';

import BuildViewerComponent from './../Components/BuildViewerComponent.jsx';
import {
  getBuildPageBuilds,
  getBuildPageBaselineBuilds,
  getBaselineBuildInfo,
  getBuildInfo,
  getBuilds
} from './../reducers';
import { modal as modalActions } from './../actions';

export class BuildViewerContainer extends React.Component {
  static propTypes = {
    buildNumber: PropTypes.number.isRequired,
    showNoBuildToast: PropTypes.func.isRequired,
    builds: PropTypes.array.isRequired,
    buildsLoaded: PropTypes.bool
  };

  constructor() {
    super();
    this.state = { lastBuildNumber: 0 };
  }

  componentDidUpdate() {
    if (!this.props.buildsLoaded ||
        this.state.lastBuildNumber === this.props.buildNumber) {
      return;
    }

    if (this.props.builds.length === 0) {
      this.props.showNoBuildToast();

    }

    this.setState({ lastBuildNumber: this.props.buildNumber });
  }

  render() {
    return (
      <BuildViewerComponent
        {...this.props}
      />
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    buildsLoaded: getBuilds(state).length > 0,
    buildNumber: getBuildInfo(state).buildNumber,
    builds: getBuildPageBuilds(state),
    baselineBuilds: getBuildPageBaselineBuilds(state),
    baselineBuildType: getBaselineBuildInfo(state).buildType
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onShowBaselineSelectorModal: () =>
      dispatch(modalActions.showBuildSelectorModal(true, true)),
    showNoBuildToast: () => {
      toastr.warning(
        'No Builds', 'No builds found with that build number.'
      );
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuildViewerContainer);


// WEBPACK FOOTER //
// src/Containers/BuildViewerContainer.jsx